// extracted by mini-css-extract-plugin
module.exports = {"iframes_container":"MapStore_iframes_container__tJUaj","iframes_smaller_imgs":"MapStore_iframes_smaller_imgs__1_u9X"};